import { ArrowUpDown, ArrowUp, ArrowDown } from 'lucide-react'
import { TableHead } from '@/components/shadcn/table'
import { OrderType } from '@/api/model'

interface SortableTableHeadProps {
  field: string
  currentSort?: string
  currentOrder?: OrderType
  onSort: (sort: string | undefined, order: OrderType | undefined) => void
  children: React.ReactNode
  className?: string
}

export function SortableTableHead({ field, currentSort, currentOrder, onSort, children, className }: SortableTableHeadProps) {
  const isActive = currentSort === field

  const handleClick = () => {
    if (!isActive) {
      onSort(field, OrderType.Ascending)
    } else if (currentOrder === OrderType.Ascending) {
      onSort(field, OrderType.Descending)
    } else {
      onSort(undefined, undefined)
    }
  }

  return (
    <TableHead className={`cursor-pointer select-none ${className ?? ''}`} onClick={handleClick}>
      <div className="flex items-center gap-1">
        {children}
        {!isActive && <ArrowUpDown className="size-3.5 text-muted-foreground" />}
        {isActive && currentOrder === OrderType.Ascending && <ArrowUp className="size-3.5 text-primary" />}
        {isActive && currentOrder === OrderType.Descending && <ArrowDown className="size-3.5 text-primary" />}
      </div>
    </TableHead>
  )
}
